<!-- 통합보고서 > 메인 -->
<template>
  <div class="tr-page-wrap">
    <div class="tit-group">
      <h2 class="tit">{{t('message.integratedReport')}}</h2>
    </div>
    <div class="page3">
      <div class="tab-group">
        <v-tabs
          v-model="tab"
        >
          <v-tab value="tabCont1">{{t('message.report')}}</v-tab>
          <v-tab value="tabCont2" v-if="false">{{t('message.safetyLeadership')}}</v-tab>
        </v-tabs>
      </div>
      <div class="content-box bg-none tab-cont-wrap">
        <v-tabs-window v-model="tab">
          <v-tabs-window-item value="tabCont1">
            <totalReportTabCont1 :is-active="tab === 'tabCont1'"/>
          </v-tabs-window-item>
          <v-tabs-window-item value="tabCont2">
            <totalReportTabCont2 :is-active="tab === 'tabCont2'"/>
          </v-tabs-window-item>
        </v-tabs-window>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'
import { useRoute } from 'vue-router'
import { useCommonStore } from "@/store/common";
import { storeToRefs } from 'pinia'
import { useI18n } from 'vue-i18n';
const { t } = useI18n();

const route = useRoute()
const store = useCommonStore()
const storeRef = storeToRefs(store)
const tab = ref('')
</script>


<style lang="scss">

</style>
